module.exports = __webpack_public_path__ + "static/img/6.161de8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/eng/6.png
// module id = Gea0
// module chunks = 0